import debounce from 'debounce-promise';

export const _submit = ({
  onSubmit,
  initialState,
  createTeamForm,
  withHistory,
  isEdit,
  withoutBackfill
}) => {
  if (isEdit) {
    const { contributor_ids: initialContributorIds = [] } = initialState;
    const { contributor_ids: newContributorIds = [] } = createTeamForm;
    const contributorsToRemove = initialContributorIds.filter(
      contributorId => !newContributorIds.includes(contributorId)
    );
    const contributorsToAdd = newContributorIds.filter(
      contributorId => !initialContributorIds.includes(contributorId)
    );
    return onSubmit({
      ...createTeamForm,
      contributorsToAdd,
      contributorsToRemove,
      with_history: !withoutBackfill.withoutBackfill
    });
  }
  onSubmit({
    ...createTeamForm,
    with_history: withHistory.withHistory
  });
};

export const submit = debounce(
  ({
    onSubmit,
    initialState,
    createTeamForm,
    withHistory,
    isEdit,
    withoutBackfill
  }) =>
    _submit({
      onSubmit,
      initialState,
      createTeamForm,
      withHistory,
      isEdit,
      withoutBackfill
    }),
  2000
);
